import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment.prod';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ArbameService {
  constructor(private httpClient: HttpClient) {
  }

  appInit(): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/customer/app_init`);
  }

  getCaptcha(): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/captcha/api/mini`);
  }

  login(data): Observable<any> {
    //email password
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/login`, data);
  }

  forgetCode(data): Observable<any> {
    //email
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/forget_trade_code`, data);
  }

  registerRequest(data): Observable<any> {
    //first_name last_name email phone_number message company_name company_website rote=trade distributor
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/register`, data);
  }

  addToBasket(data): Observable<any> {
    //cart_group_id product_id amount
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/add_to_cart`, data);
  }

  setAmountToCartItem(data): Observable<any> {
    //cart_group_id product_id amount
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/add_or_minus_amount`, data);
  }

  deleteFromCart(data): Observable<any> {
    //cart_group_id product_id amount
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/delete_from_cart`, data);
  }

  getCart(id, data): Observable<any> {
    console.log('load cardddddd');
    //cart_group_id product_id amount
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/get_cart/${id}`, data);
  }

  getProfile(): Observable<any> {
    //cart_group_id product_id amount
    return this.httpClient.get<any>(`${environment.endpoint}/api/customer/get_profile`);
  }

  getOrders(data): Observable<any> {

    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/carts_list`, data);
  }

  setStatusToCart(data): Observable<any> {
    //cart_group_id  city street apartment postal_code order_note
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/set_status_to_cart`, data);
  }

  getMenu(): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/menu`);
  }

  getAddress(): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/customer/get_address`);
  }

  setAddress(fd): Observable<any> {
    //city street apartment address postal_code
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/set_address`, fd);
  }

  employeesList(): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/customer/employees_list`);
  }

  createEmployee(fd): Observable<any> {
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/create_employee`, fd);
  }

  deleteEmployee(id): Observable<any> {
    return this.httpClient.delete<any>(`${environment.endpoint}/api/customer/delete_employee/${id}`);
  }

  logOut(): Observable<any> {
    return this.httpClient.get<any>(`${environment.endpoint}/api/customer/logout`);
  }

  sendEvent(data): Observable<any> {
    return this.httpClient.post<any>(`${environment.endpoint}/api/set_event`, data);
  }

  search(data): Observable<any> {
    return this.httpClient.post<any>(`${environment.endpoint}/api/simple_search`, data);
  }

  changePassword(data): Observable<any> {
    return this.httpClient.post<any>(`${environment.endpoint}/api/customer/update_code`, data);
  }
  contact(data): Observable<any> {
    return this.httpClient.post<any>(`${environment.endpoint}/api/contact`, data);
  }
}

